<h4 class="text-center">{{ 'CLAIM_FOR_ORDER_NO' | translate }}: {{orderId}} </h4>
<div *ngIf="loaded">
<div class="row justify-content-center">
    <div class="col-12 col-md-10 col-lg-8">
        <h5 class="sub-heading text-sm" translate>CHECK_ORDER_LINES_TO_CLAIM</h5>
        <div class="form-group">
            <div class="row" [formGroup]="form">
                <div class="col-12">
                    <table class="table">
                        <thead>
                            <tr>
                                <th scope="col" translate>RETURN</th>
                                <th scope="col" translate>LINE</th>
                                <th scope="col" translate>ARTICLE_NO</th>
                                <th scope="col" translate>PRODUCT_DESCRIPTION</th>
                                <th scope="col" translate>QUANTITY</th>
                                <th scope="col" translate>QUANTITY_TO_CLAIM</th>
                                <th scope="col" translate>REASON_FOR_CLAIM</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let orderLine of orderRowsActivated">
                                <td class="align-middle">
                                    <input
                                        type="checkbox"
                                        [formControlName]="'claim' + removeDots(orderLine.rownr + orderLine.productId)"
                                        class="form-check-input"
                                    />
                                </td>
                                <td class="align-middle">{{orderLine.rownr}}</td>
                                <td class="align-middle">{{orderLine.productId}}</td>
                                <td class="align-middle">{{orderLine.extra.orp.artbeskr}}</td>
                                <td class="align-middle">{{orderLine.quantity}} {{orderLine.extra.orp.enhetskod}}</td>
                                <td class="align-middle">
                                    <div class="d-flex align-items-center" *ngIf="form.get('claim' + removeDots(orderLine.rownr + orderLine.productId))?.value">
                                        <lib-gung-text-input-horizontal
                                            [suppressLabel]="true"
                                            [formControlName]="'quantityToClaim' + removeDots(orderLine.rownr + orderLine.productId)"
                                        />
                                        <span class="ms-2">{{orderLine.extra.orp.enhetskod | translate}}</span>
                                    </div>
                                </td>
                                <td class="align-middle">
                                    <lib-gung-select-option-input-horizontal
                                        *ngIf="form.get('claim' + removeDots(orderLine.rownr + orderLine.productId))?.value"
                                        [suppressLabel]="true"
                                        [optionsList]="claimReasons"
                                        [formControlName]="'claimReason' + removeDots(orderLine.rownr + orderLine.productId)"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="row" [formGroup]="form">
                <lib-gung-text-area-input
                    gungTranslate="WHICH_SOLUTION_DO_YOU_WISH"
                    formControlName="solution"
                    [placeholder]="'WISHED_SOLUTION' | translate"
                ></lib-gung-text-area-input>
            </div>
            
            <div class="row" [formGroup]="form">
                <div class="col-12">
                    <button class="btn btn-outline-primary mt-3" (click)="inputFile.click()" >
                        + {{ "CHOOSE_IMAGES_OPTIONAL" | translate}}
                        <input hidden
                            #inputFile
                            type="file"
                            multiple
                            accept="image/*"
                            class="_custom-file-input"
                            id="inputGroupFile01"
                            aria-describedby="inputGroupFileAddon01"
                            (change)="addImages($event)"
                        />
                    </button>
                </div>
                <div class="col-12 d-flex flex-wrap gap-2 mt-3" *ngIf="imagePreviews.length">
                    <div *ngFor="let preview of imagePreviews; let i = index" class="position-relative">
                        <img [src]="preview.url" [alt]="preview.file.name"
                             style="width: 96px; height: 96px; object-fit: cover; border-radius: 4px; border: 1px solid #dee2e6;" />
                        <button type="button"
                                class="btn btn-sm btn-light position-absolute top-0 end-0 p-0 px-1"
                                style="line-height: 1;"
                                (click)="removeImage(i)"
                                [attr.aria-label]="'REMOVE' | translate">&times;</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<div class="row justify-content-center mt-3">
    <div class="col-12 col-md-10 col-lg-8 d-flex justify-content-between">
        <button class="btn btn-outline-primary" (click)="cancel()" translate>CANCEL</button>
        <button class="btn btn-primary" (click)="registerClaim()" translate>REGISTER_CLAIM</button>
    </div>
</div>
</div>